<script lang="ts">
    import { tgettext } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'

    import { Breadcrumb } from 'breadcrumb'

    const crumbs = [
        {
            txt: tgettext('Invoice Message'),
        },
    ]

    let messages = $state({
        en: '',
        fr: '',
    })

    function clearMessages() {
        messages = {
            en: '',
            fr: '',
        }
    }

    let working = $state(false)
    async function loadMessage() {
        working = true
        let r: SimpleFetchResult
        try {
            r = await simpleFetch('GET', '/json/ecom/1/user-accounting-invoice-message')
            clearMessages()
            for (const mlg of r.data.message) {
                messages[mlg.lg] = mlg.text
            }
        } catch (e) {
            console.error('Error:', e)
            notify({
                type: 'danger',
                title: 'Message',
                text: 'Le message n’a pas pu être chargé suite à une erreur.',
            })
        }

        working = false
    }
    loadMessage()

    async function saveMessage() {
        working = true

        let data = Object.entries(messages).map(([l, m]) => {
            return { lg: l, text: m }
        })

        let r: SimpleFetchResult
        try {
            r = await simpleFetch('PUT', '/json/ecom/1/user-accounting-invoice-message', { message: data })
            notify({
                type: 'success',
                title: 'Message',
                text: 'Succès de sauvegarde.',
            })
        } catch (e) {
            console.error('Error:', e)
            notify({
                type: 'danger',
                title: 'Message',
                text: 'La sauvegarde a généré une erreur.',
            })
        }

        working = false
    }
</script>

<Breadcrumb {crumbs} />

<form
    onsubmit={(e) => {
        e.preventDefault()
        saveMessage()
    }}
>
    <div class="card">
        <div class="card-title text-primary">Message de facturation.</div>
        <div class="card-body">
            <p>Ce message est affiché dans la boîte « Message » sur les factures.</p>
            <p>Il est sauvegardé dans une commande au moment de sa création, et n’apparaît qu’après un paiement réussi.</p>
            <div class="form-group">
                <label for="fr" class="col-form-label">Français</label>
                <input type="text" class="form-control" disabled={working} bind:value={messages.fr} name="fr" />
            </div>
            <div class="form-group">
                <label for="en" class="col-form-label">Anglais</label>
                <input type="text" class="form-control" disabled={working} bind:value={messages.en} name="en" />
            </div>
        </div>
        <div class="card-footer text-bg-light text-end">
            <button type="submit" class="btn btn-primary" disabled={working}>Save</button>
        </div>
    </div>
</form>
